import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxWidth: '100%',

      '& input': {
        fontSize: theme.typography.appFontSize,
      },
    },
  };
});

export default useStyles;
